module.exports = __webpack_public_path__ + "assets/svg/Icons/32/timesheet-green-422fea.svg";